module.exports = {
  "zones": {
    "Antarctica/Casey": ["z", {
      "wallclock": 1520740800000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": 1520701200000,
      "save": 0
    }, {
      "wallclock": 1477094400000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": 1477065600000,
      "save": 0
    }, {
      "wallclock": 1329883200000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": 1329843600000,
      "save": 0
    }, {
      "wallclock": 1319767200000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": 1319738400000,
      "save": 0
    }, {
      "wallclock": 1267754400000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": 1267714800000,
      "save": 0
    }, {
      "wallclock": 1255831200000,
      "format": "+11",
      "abbrev": "+11",
      "offset": 39600000,
      "posix": 1255802400000,
      "save": 0
    }, {
      "wallclock": -31536000000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": -31536000000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "-00",
      "abbrev": "-00",
      "offset": 0,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};